import { AppHeader } from "@/components/AppHeader"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { useBrandConfig } from "@/hooks/useBrandConfig"
import { useMyUsage } from "@/hooks/useMyUsage"
import { TenantMonthlyBanner } from "@/components/usage/TenantMonthlyBanner"

type ChatHeaderProps = {
  title?: string | undefined
  projectName?: string
  chatTitle?: string
  onNewChat?: () => void
  canStartNewChat?: boolean
}

export function ChatHeader({ title, projectName, chatTitle }: ChatHeaderProps) {
  const brand = useBrandConfig()
  const { usage } = useMyUsage()

  const displayTitle = chatTitle || projectName || title || brand.appTitle
  const subtitle = chatTitle && projectName ? projectName : undefined
  // ブランド名マーク（AppHeader 左端）と同じ文字列ならタイトル欄には出さない（重複表示回避）。
  const headerTitle = displayTitle === brand.appTitle ? undefined : displayTitle

  return (
    <>
      <AppHeader
        leading={<SidebarTrigger className="shrink-0 text-white hover:bg-white/10 hover:text-white" />}
        title={headerTitle}
        subtitle={subtitle}
        usage={usage}
      />
      {/* テナント月次の利用枠バナー（上限設定時のみ表示）。 */}
      <TenantMonthlyBanner usage={usage} />
    </>
  )
}
